import { apiFetch } from '@/lib/api';

export interface LanguageCoverage { code: string; name: string; count: number; pct: number }
export interface LanguagesStats {
  total: number;
  enabled: number;
  bundled: number;
  custom: number;
  total_ui_keys: number;
  avg_coverage_pct: number;
  coverage: LanguageCoverage[];
}

export function getLanguagesStats(): Promise<LanguagesStats> {
  return apiFetch<LanguagesStats>('/languages-admin/stats');
}
